// extracted by mini-css-extract-plugin
export default {"root":"PaymentInformationBlock_root-Skz","safeBlock":"PaymentInformationBlock_safeBlock-Exd","list":"PaymentInformationBlock_list-onI"};